import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BadgePreviewContainer } from '../StyledComponents/Div';
import BadgePreview from '../Registration/BadgePreview';
import Coupon from '../Registration/Coupon';

export default function BadgePanel({
  badgeTemplate,
  componentRef,
  market,
  companyAssociation,
  guestBadges,
  tags,
}) {
  const [coupons, setCoupons] = useState([]);
  const marketId = market?.marketId || 0;
  const attendanceTypeId =
    companyAssociation?.associationType?.attendanceType?.attendanceTypeId || 0;
  const businessTypeId =
    companyAssociation?.company?.businessType?.businessTypeId || 0;

  return (
    <div>
      <BadgePreviewContainer style={{ display: 'none' }}>
        <div ref={componentRef}>
          <BadgePreview
            badgeTemplate={badgeTemplate && badgeTemplate.badgeHtml}
            badgeData={{ companyAssociation, market, tags }}
            couponHtml={coupons}
          />
          {guestBadges?.map((html, idx) => (
            <div
              key={idx}
              className="guest"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          ))}
          <Coupon
            marketId={marketId}
            attendanceTypeId={attendanceTypeId}
            businessTypeId={businessTypeId}
            setCouponHtml={setCoupons}
          />
        </div>
      </BadgePreviewContainer>
    </div>
  );
}

BadgePanel.propTypes = {
  badgeTemplate: PropTypes.shape(),
  componentRef: PropTypes.shape().isRequired,
  market: PropTypes.shape().isRequired,
  companyAssociation: PropTypes.shape(),
  guestBadges: PropTypes.arrayOf(PropTypes.string).isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape()),
};

BadgePanel.defaultProps = {
  companyAssociation: null,
  badgeTemplate: null,
  tags: null,
};
